<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="Service Update"
    width="500px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="true"
    custom-class="update-notice-dialog"
  >
    <div class="update-notice-content">
      <i class="el-icon-info notice-icon" />
      <p class="notice-text">
        We now support real-time trucking fee checking within the U.S. and Canada region. Click the <a href="https://buxdmzd9k0.feishu.cn/docx/SQtGdmDcfoFhwWxFWUkcyTnmn8g?source_type=message&from=message&disposable_login_token=eyJ1c2VyX2lkIjoiNzQ4NTE4NTc5ODc5OTcwNDA2NyIsImRldmljZV9sb2dpbl9pZCI6Ijc0OTIwNjY0NDI2MzcwNjYyNDMiLCJ0aW1lc3RhbXAiOjE3Nzg0OTM4MzgsInVuaXQiOiJldV9uYyIsInB3ZF9sZXNzX2xvZ2luX2F1dGgiOiIxIiwidmVyc2lvbiI6InYzIiwidGVuYW50X2JyYW5kIjoiZmVpc2h1IiwicGtnX2JyYW5kIjoi6aOe5LmmIn0=.2f4c28c964e4df1f9a3424690626e8cd6dc5cf2141e223a9c612939b66fe5b73" target="_blank" class="doc-link">operation document</a> to view details.
      </p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Close</el-button>
      <el-button type="primary" @click="handleConfirm">Confirm</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Cookie } from '@yld/yun-utils-common'

const COOKIE_KEY = 'update_notice_seen_v1'

export default {
  name: 'UpdateNoticeModal',
  data() {
    return {
      dialogVisible: false
    }
  },
  mounted() {
    this.checkAndShow()
  },
  methods: {
    // 检查是否需要显示提示
    checkAndShow() {
      const hasSeenNotice = Cookie.getCookie(COOKIE_KEY, null, false)
      if (!hasSeenNotice) {
        // 延迟显示，确保页面加载完成
        this.$nextTick(() => {
          setTimeout(() => {
            this.dialogVisible = true
          }, 300)
        })
      }
    },

    // 确认按钮处理 - 存储标记，不再显示
    handleConfirm() {
      Cookie.setCookie(COOKIE_KEY, 'true', false)
      this.dialogVisible = false
      this.$emit('confirm')
    },

    // 关闭处理 - 存储标记，不再显示
    handleClose() {
      Cookie.setCookie(COOKIE_KEY, 'true', false)
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.update-notice-content {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 8px 0;
}

.notice-icon {
  font-size: 48px;
  color: #6366F1;
  flex-shrink: 0;
  margin-top: 4px;
}

.notice-text {
  font-size: 15px;
  color: #374151;
  line-height: 1.6;
  margin: 0;
}

.doc-link {
  color: #6366F1;
  text-decoration: underline;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #4F46E5;
    text-decoration: underline;
  }
}
</style>

<!-- 非 scoped 样式，用于覆盖 Element UI dialog 样式 -->
<style lang="scss">
.update-notice-dialog {
  border-radius: 16px;
  overflow: hidden;

  .el-dialog__header {
    padding: 24px 24px 16px;
    margin: 0;
    border-bottom: 1px solid #E5E7EB;
  }

  .el-dialog__title {
    font-size: 20px;
    font-weight: 700;
    color: #1a1a2e;
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 16px 24px 24px;
    border-top: 1px solid #E5E7EB;
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
    gap: 12px;

    .el-button {
      min-width: 100px;
      height: 40px;
      font-size: 15px;
      font-weight: 500;
      border-radius: 8px;
    }
  }
}
</style>
